<template>
    <div class="container-fluid">
        <b-tabs v-model="tabIndex" content-class="mt-3">
            <b-tab title="Consulter" @click="updateMode(false, false)" active>
              <b-card class="mb-1 leftAlign">
                <div v-if="responsesList.length > 1" >
                  <b-form-group label-for="phoneticTranscriptionConsult" description="Dérouler la liste pour choisir une autre transcription phonétique">
                    <b-form-select id="phoneticTranscriptionConsult" :options="responsesList"  value-field="rousselotPhoneticForm"
                         text-field="rousselotPhoneticForm"
                          size="lg" v-model="phoneticTranscription">
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="mb-1" v-if="phoneticTranscription != null && invEntrySameRousselotPhoneticFormList.length === 1">
                        <p class="formGroupTitle">Aucun autre point d'enquête ne partage cette transcription</p>
                </div>
                <div class="mb-1" v-if="phoneticTranscription != null && invEntrySameRousselotPhoneticFormList.length > 1">
                        <p class="formGroupTitle">Liste des points d'enquête partageant cette transcription</p>
                        <b-card bg-variant="light">
                            <b-card-text id="selectedinvEntries" class="overflow-auto">
                                <span v-for="(inventoryEntry, index) in invEntrySameRousselotPhoneticFormList" :key="inventoryEntry.inventoryEntry">
                                   {{ currentInventoryEntry.spIdentifier != inventoryEntry.spIdentifier ?  inventoryEntry.spIdentifier : ''}} 
                                   {{ currentInventoryEntry.spIdentifier < inventoryEntry.spIdentifier  && index < invEntrySameRousselotPhoneticFormList.length - 1 ? ', ' : ''}}
                                   {{ currentInventoryEntry.spIdentifier > inventoryEntry.spIdentifier  && index < invEntrySameRousselotPhoneticFormList.length - 2 ? ', ' : ''}}
                                 </span>
                            </b-card-text>
                        </b-card>
                </div>
              </b-card>
            </b-tab>
            <b-tab v-if="isAuthenticated" title="Editer" @click="updateMode(false, true)">
               <phonetic-transcriptions-edition v-bind:responsesList="responsesList"></phonetic-transcriptions-edition>
            </b-tab>
            <b-tab title="Supprimer" v-if="isAuthenticated" @click="updateMode(true, true)">
              <phonetic-transcriptions-suppression  v-bind:responsesList="responsesList">
              </phonetic-transcriptions-suppression>
            </b-tab>
            <b-tab title="Ajouter" v-if="isAuthenticated" @click="manageDataForCreation()">
            <phonetic-transcriptions-creation v-on:closePhoneticTranscriptionCreation="closeSideBar()"></phonetic-transcriptions-creation>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PhoneticTranscriptionsEdition from '@components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsEdition'
import PhoneticTranscriptionsSuppression from '@components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsSuppression'
import PhoneticTranscriptionsCreation from '@components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsCreation'

export default {
  name: 'PhoneticTranscriptionsConsultation',
  props: ['responsesList'],
  data(){
      return { 
        phoneticTranscription: null,
        tabIndex: 0
      }
  },
  components: { PhoneticTranscriptionsEdition, PhoneticTranscriptionsSuppression, PhoneticTranscriptionsCreation },
  computed: {
    ...mapGetters({
      currentInventoryEntry: 'getCurrentInventoryEntry',
      invEntrySameRousselotPhoneticFormList: 'getInvEntrySameRousselotPhoneticFormList',
      isAuthenticated: 'getIsAuthenticated'
    })
  },
  created() { 
    this.phoneticTranscription = this.responsesList[0].rousselotPhoneticForm
    this.$store.commit('UPDATE_ISPHONETICTRANSCRIPTIONEDITIONMODE', false) 
    },
  watch: {
    currentInventoryEntry() { this.tabIndex = 0 },
    responsesList() { this.phoneticTranscription = this.responsesList[0].rousselotPhoneticForm },
    phoneticTranscription() { 
      this.$store.dispatch('reloadData', { invEntrySameRousselotPhoneticFormList: this.invEntrySameRousselotPhoneticFormList, phoneticTranscription: this.phoneticTranscription})
    }
  },
  methods: {
    // Met à jour les modes
    updateMode: function(isDeleteMode, isPhoneticTranscriptionEditionMode) {
      this.$store.commit('UPDATE_ISDELETEMODE', isDeleteMode)
      this.$store.commit('UPDATE_ISPHONETICTRANSCRIPTIONEDITIONMODE', isPhoneticTranscriptionEditionMode)
    },
    // Restauration des couleurs de disques et la liste des disques pour le mode création
    manageDataForCreation: function() {
      this.$store.dispatch('restaureCirclesForPhoneticTranscriptionMode', this.invEntrySameRousselotPhoneticFormList)
      this.$store.commit('UPDATE_ISPHONETICTRANSCRIPTIONEDITIONMODE', true)
      this.$store.dispatch('resetCircleList', false)
    },
    // Femer le bandeau latéral
    closeSideBar: function() { 
      this.$store.dispatch('closeSideBar', this.mode) 
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsConsultation.vue